module.exports = __webpack_public_path__ + "static/media/vaccinations.10d83b41.svg";